import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

function TestimonialsHome() {
    return (
        <MKBox component="section" pt={{ xs: 8, md: 10 }} pb={{ xs: 3, md: 5 }}>
            <Container>
                <Grid container item xs={12} lg={10} sx={{ mx: "auto" }}>
                    <MKTypography variant="h2" color="dark" mb={3} sx={{ textWrap: "balance" }}>
                        Întreținerea pardoselilor sau spălarea pardoselilor
                    </MKTypography>
                    <MKBox component="ul" pl={4} mb={5}>
                        <MKTypography
                            component="li"
                            variant="body1"
                            color="text"
                            mb={2}
                            sx={{ textWrap: "pretty" }}
                        >
                            În spații de dimensiuni mici și medii se utilizează echipamente de
                            dimensiuni reduse, cu autonomie proprie, iar în spațiile greu accesibile
                            sau cu diferențe de nivel se folosesc sisteme de curățare manuală.
                        </MKTypography>
                        <MKTypography
                            component="li"
                            variant="body1"
                            color="text"
                            sx={{ textWrap: "pretty" }}
                        >
                            În spații de dimensiuni mari se utilizează echipamente alese în funcție
                            de randamentul suprafață/oră, cu autonomie conform graficului și front
                            mare de lucru, cu om la bord sau automatizate. Se pot folosi și sisteme
                            adaptate, cu roboți corelați pentru curățarea și întreținerea continuă a
                            suprafețelor.
                        </MKTypography>
                    </MKBox>

                    <MKTypography variant="h2" color="dark" mb={3} sx={{ textWrap: "balance" }}>
                        Curățarea pardoselilor sau spălarea în profunzime
                    </MKTypography>
                    <MKTypography variant="body1" color="text" mb={3} sx={{ textWrap: "pretty" }}>
                        Acest proces începe cu un studiu atent asupra materialului, mediului și
                        gradului de murdărie.
                    </MKTypography>
                    <MKTypography variant="body1" color="text" mb={3} sx={{ textWrap: "pretty" }}>
                        Procedura de lucru constă în identificarea soluției tehnice, stabilirea
                        metodei de curățare și alegerea detergenților utilizați.
                    </MKTypography>
                    <MKTypography variant="body1" color="text" sx={{ textWrap: "pretty" }}>
                        Etapa mecanizată, în concordanță cu detergenții speciali, curăță suprafața
                        în profunzime prin procese de degresare, decapare, decalcifiere și
                        deceruire. În majoritatea cazurilor, aceasta este etapa pregătitoare pentru
                        finisarea sau protejarea pardoselilor prin ceruire, sigilare ori
                        impermeabilizare.
                    </MKTypography>
                </Grid>
            </Container>
        </MKBox>
    );
}

export default TestimonialsHome;
